import type { ReactNode } from 'react';
import { cn } from '../../lib/cn';

export interface StatProps {
  label: string;
  value: ReactNode;
  hint?: ReactNode;
  className?: string;
  valueClassName?: string;
}

export const Stat = ({ label, value, hint, className, valueClassName }: StatProps) => (
  <div className={cn('rounded-lg border border-border bg-surface px-3 py-2.5', className)}>
    <p className="text-[12px] font-medium uppercase tracking-wide text-ink-subtle">{label}</p>
    <p className={cn('mt-1 text-[22px] font-semibold leading-none text-ink', valueClassName)}>
      {value}
    </p>
    {hint ? <p className="mt-1 text-[12px] text-ink-muted">{hint}</p> : null}
  </div>
);
